import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { CropNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-crop',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
  templateUrl: './edit-crop.component.html',
  styleUrl: './edit-crop.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditCropComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditCropComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<CropNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.CROP.NAME'), [Validators.required]],
    scale: [null, [Validators.required]],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        scale: this.selectedNodeForEdit().data.scale,
      })
    }
  }
}
